export default __webpack_public_path__ + "static/char-s-50-ko-d62c5b7d22d68e568f5868af84ea72ba.png";